import MobileLanding from './MobileLanding';

export default MobileLanding;
